import { useContext } from "react";

import queryString from "query-string";

import { Info } from "components/elements";
import { Overlay, Section, TablePagination } from "components/layout";
import { useManifestHistory } from "hooks/manifests";
import { useRouter } from "hooks/utils";
import { trans } from "src/translations";
import { formatDate } from "utils/date";

import { ManifestDataContext } from "../ManifestData";
import { Author, ManifestDetailsTable } from "./components";

const PAGE_SIZE = 5;

export const ManifestChangelogTab = () => {
  const { loading, manifest } = useContext(ManifestDataContext);
  const router = useRouter();
  const page = Number(queryString.parse(router.location.search).page || 1);

  const {
    data: manifestHistory,
    isPending,
    isError,
  } = useManifestHistory(manifest?.id, {
    page,
    sort_desc: true,
    limit: PAGE_SIZE,
  });

  // The target is not an attribute, but we display it as if it was.
  return (
    <Overlay active={loading || isPending} message={trans.LOADING()}>
      <ManifestDetailsTable
        attributes={{
          targets: manifest?.targets,
          ...manifest?.attributes,
        }}
        collapsable
        deleted={manifest?.is_deleted}
        loading={loading}
        subheader={<Author id={manifestHistory?.results[0]?.modified_by} />}
      />
      <Section header={trans.APP_MANIFESTS_CHANGELOG_HEADER()}>
        {isError && <Info type="error">{trans.DEFAULT_ERROR_MESSAGE()}</Info>}
        {manifestHistory?.results.map(
          ({
            id,
            attributes,
            is_deleted,
            modified_by,
            modified_date,
            targets,
          }) => (
            <ManifestDetailsTable
              key={id}
              attributes={{ targets, ...attributes }}
              collapsable
              deleted={is_deleted}
              header={formatDate(new Date(modified_date))}
              loading={isPending}
              subheader={<Author id={modified_by} />}
              targets={targets}
            />
          )
        )}
        <TablePagination
          rowsPerPage={PAGE_SIZE}
          totalCount={manifestHistory?.meta?.total}
        />
      </Section>
    </Overlay>
  );
};
